export function encodeAgencyCode(agency_id: string) {
  let code = btoa(agency_id);
  code = code.split('').reverse().join('');
  code = "x" + code;
  code = code.replace(/=/g, "$");
  return code;
}
